import { render, staticRenderFns } from "./franchise-qty.vue?vue&type=template&id=fab49f20&"
import script from "./franchise-qty.vue?vue&type=script&lang=js&"
export * from "./franchise-qty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports